import { useMutation, useQueryClient } from 'react-query';

import { UpdateCertificateResponse, updateRestaurantCertificate, updateRestaurantDigitalCertificate } from '../lib/certificate';
import { UpdateRestaurantResponse } from '../lib/restaurant';
import { SwornDeclarationSchemaType } from '@/components/organisms/SwornDeclarationForm/schema';
import { DigitalDeclarationSchemaType } from '@/components/pages/Restaurant/CertificatePage/schema';

export const useUpdateRestaurantCertificate = (restaurantId: string, onSuccess: (data: UpdateRestaurantResponse) => void) => {
  const queryClient = useQueryClient();

  return useMutation<UpdateRestaurantResponse, Error, SwornDeclarationSchemaType>((params) => updateRestaurantCertificate(restaurantId, params), {
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['restaurant', restaurantId] });
      onSuccess(data);
    }
  });
};


export const useUpdateRestaurantDigitalCertificate = (restaurantId: string) => {
  const queryClient = useQueryClient();

  return useMutation<UpdateRestaurantResponse, Error, DigitalDeclarationSchemaType>((params) => updateRestaurantDigitalCertificate(restaurantId, params), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['restaurant', restaurantId] });
    }
  });
};
